// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  billId: __t.u64().primaryKey().name("bill_id"),
  civ: __t.string(),
  kind: __t.string(),
  value: __t.i32(),
  prior: __t.i32(),
  status: __t.string(),
  round: __t.i32(),
  proposedBy: __t.u64().name("proposed_by"),
  text: __t.string(),
  yesVotes: __t.i32().name("yes_votes"),
  noVotes: __t.i32().name("no_votes"),
  yesPop: __t.i32().name("yes_pop"),
  noPop: __t.i32().name("no_pop"),
  source: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  decidesAt: __t.timestamp().name("decides_at"),
});
